import { RcThemeInput } from '@ringcentral/juno';
import { overridesFactory } from '@/shared/theme/utils/overrides.factory';
import { paletteFactory } from '@/shared/theme/utils/palette.factory';

interface ThemeBuilderOptions {
  colors: {
    primaryColor: string;
    secondaryColor: string;
  };
}

export const buildTheme = (options: ThemeBuilderOptions): RcThemeInput => {
  return {
    typography: {
      fontFamily: `'ProximaNova-Regular', Helvetica, Arial, sans-serif`,
    },
    palette: paletteFactory(
      options.colors.primaryColor,
      options.colors.secondaryColor,
    ),
    overrides: overridesFactory(options.colors.primaryColor),
  };
};
